export default "__VITE_ASSET__ecfe085d__"